module.exports = __webpack_public_path__ + "img/active-effect-nav-title.png.ddef69ca.png";